var _path, _path2, _circle, _circle2, _path3, _path4, _path5, _rect, _path6, _circle3, _path7, _path8, _path9, _path10, _g, _path11;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAbtU(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    width: 694.08197,
    height: 576.15801,
    viewBox: "0 0 694.08197 576.15801",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "a21d7543-5d63-4074-9205-f06443f25821",
    "data-name": "Group 73"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "e7fbd27d-1c9f-4a62-8148-82b039061e33-84",
    "data-name": "Path 1083",
    d: "M584.091,298.837h3.166V212.114a50.193,50.193,0,0,1,50.193-50.193H821.186a50.193,50.193,0,0,1,50.193,50.193V687.885a50.193,50.193,0,0,1-50.193,50.193H637.45a50.193,50.193,0,0,1-50.193-50.193V360.568h-3.166Z",
    transform: "translate(-252.95901 -161.92099)",
    fill: "#3f3d56"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "f17a8b50-0b0b-47cc-a298-09bd9c200760-85",
    "data-name": "Path 1084",
    d: "M635.425,174.98h23.984a17.808,17.808,0,0,0,16.488,24.534H781.156a17.808,17.808,0,0,0,16.488-24.534h22.4a37.484,37.484,0,0,1,37.485,37.483V687.537a37.484,37.484,0,0,1-37.484,37.484H635.425a37.484,37.484,0,0,1-37.484-37.484h0V212.465a37.484,37.484,0,0,1,37.484-37.484h0Z",
    transform: "translate(-252.95901 -161.92099)",
    fill: "#fff"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "b774a52b-05ed-4103-aa7f-8d237ff42447",
    "data-name": "Ellipse 206",
    cx: 474.77603,
    cy: 396.22202,
    r: 42.565,
    fill: "#ccc"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "fbab1c94-d57e-450f-bea0-7a43d993a063",
    "data-name": "Ellipse 221",
    cx: 474.776,
    cy: 396.22099,
    r: 40.444,
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "b77f917d-34fd-4c03-b75e-73ab726170c9-86",
    "data-name": "Path 1087",
    d: "M720.982,575.832l-12.739-16.381,7.408-5.762,6.032,7.756,20.379-21.512,6.815,6.456Z",
    transform: "translate(-252.95901 -161.92099)",
    fill: "#00b0ff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "e471b633-d198-47ad-a91d-7bccaed22689-87",
    "data-name": "Path 1121",
    d: "M625.189,640.92,649.8,629.435v6.563h57.426v9.844H649.8v6.563Z",
    transform: "translate(-252.95901 -161.92099)",
    fill: "#00b0ff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "bad1768d-f28d-4d6c-9720-78225c848e2e-88",
    "data-name": "Path 1125",
    d: "M824.566,640.92l-24.611-11.485v6.563H742.529v9.845h57.426v6.563Z",
    transform: "translate(-252.95901 -161.92099)",
    fill: "#00b0ff"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "a0757271-aa13-4c39-883b-681fb07b8358",
    "data-name": "Rectangle 126",
    x: 374.793,
    y: 88.93702,
    width: 199.377,
    height: 209.396,
    fill: "#e6e6e6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "bd4436a9-ab86-4abe-9bd7-11c3c7af63e2",
    "data-name": "Group 71"
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "b3e8bf17-9a50-43a4-bd93-c09f4fce21e6-89",
    "data-name": "Path 973",
    d: "M700.29,427.866l-15.12,23.519h10.919Z",
    transform: "translate(-252.95901 -161.92099)",
    fill: "#e6e6e6"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id: "bfa771e6-4776-4e65-99f0-8c22976fc45f",
    "data-name": "Ellipse 182",
    cx: 464.97003,
    cy: 135.75202,
    r: 21.839,
    fill: "#feb8b8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "bc00fcfd-5730-439e-98b0-f69b404d7a35-90",
    "data-name": "Path 976",
    d: "M742.288,321.192s-10.08,3.36-15.119,9.24-16.8,6.72-16.8,6.72-10.4,5.854-14.279,15.959c-4.139,10.769-1.733,25.932,0,29.4,3.36,6.72,3.36,23.519,3.36,23.519l-4.2,38.638s-15.119,14.279-3.36,15.959,32.758-.84,45.358,0,26.879,2.52,22.679-5.88-9.24-14.279-4.2-31.078c3.944-13.146,3.773-62.3,3.512-83.052a16.71,16.71,0,0,0-8.115-14.121Z",
    transform: "translate(-252.95901 -161.92099)",
    fill: "#3f3d56"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "e078b431-7fa2-4ffb-9128-b5cbabb89faa-91",
    "data-name": "Path 977",
    d: "M709.52905,449.705s-3.821,8.414-4.2,13.439c-2.94,39.058,18.479,0,18.479,0v-6.72Z",
    transform: "translate(-252.95901 -161.92099)",
    fill: "#feb8b8"
  })), /*#__PURE__*/React.createElement("path", {
    id: "a9e0b218-7fb2-4594-9961-d5df86528afc-92",
    "data-name": "Path 980",
    d: "M730.10805,347.65l2.52,51.237-24.417,49.454-4.142-1.576,25.2-46.2Z",
    transform: "translate(-252.95901 -161.92099)",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "a63b4032-c365-49f7-ae5c-3b8abdfa447a-93",
    "data-name": "Path 981",
    d: "M749.84705,332.111l6.3-1.26s18.9,13.859,13.019,41.578-31.918,69.717-31.918,69.717-5.88,7.56-7.56,9.24-5.04,0-3.36,2.52-2.52,4.2-2.52,4.2-18.479,0-16.8-6.72,30.239-54.6,30.239-54.6l-4.2-44.518S729.68805,330.431,749.84705,332.111Z",
    transform: "translate(-252.95901 -161.92099)",
    fill: "#3f3d56"
  })), /*#__PURE__*/React.createElement("path", {
    id: "a4f11c4e-c37a-4dd8-a35d-ae47dc8b8240-94",
    "data-name": "Path 982",
    d: "M757.827,409.807v-5.88l-28.555,47.038Z",
    transform: "translate(-252.95901 -161.92099)",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "a203bd83-525b-4951-b824-caeea29adbfe-95",
    "data-name": "Path 983",
    d: "M702.435,277.437l-3.61-1.445s7.549-8.311,18.052-7.588l-2.954-3.252s7.221-2.891,13.785,4.7c3.451,3.989,7.443,8.678,9.932,13.96h3.866l-1.614,3.553,5.648,3.553-5.8-.638a19.66128,19.66128,0,0,1-.548,9.2l.155,2.808s-6.72-10.4-6.72-11.842v3.613s-3.61-3.252-3.61-5.42l-1.969,2.529-.985-3.975-12.144,3.975,1.969-3.252-7.549,1.084,2.954-3.975s-8.534,4.7-8.862,8.672-4.596,9.04-4.596,9.04l-1.969-3.613S692.914,282.861,702.435,277.437Z",
    transform: "translate(-252.95901 -161.92099)",
    fill: "#2f2e41"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a0d1e1aa-6ffe-40d9-a9d3-85056dcc97e2",
    "data-name": "Group 72"
  }, /*#__PURE__*/React.createElement("path", {
    id: "b29d9842-97e3-494c-ae66-73d780169e6a-96",
    "data-name": "Path 1133",
    d: "M444.476,376.614c-2.768-8.823-9.064-16.914-17.77-19.9s-23.895-.195-28,8.084c-5.917,11.932-3.259,26.543-.121,39.5,1.636-.087,3.287-.155,4.943-.217l2.343-7.808v7.731c12.925-.4,26.382-.149,39.846.109C446.923,394.943,447.245,385.436,444.476,376.614Z",
    transform: "translate(-252.95901 -161.92099)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "a2d5c4ab-10e8-4119-8285-6e98d5f2924d-97",
    "data-name": "Path 1134",
    d: "M325.707,712.794l10.874,4.557,22.75-39.77-16.048-6.726Z",
    transform: "translate(-252.95901 -161.92099)",
    fill: "#a0616a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "b5ab1e96-94a7-45b9-ab1b-fa72a3320944-98",
    "data-name": "Path 1135",
    d: "M318.517,722.172l35.059,14.693.186-.443a14.8,14.8,0,0,0-7.927-19.365h0l-21.413-8.974Z",
    transform: "translate(-252.95901 -161.92099)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "a7fb9385-bd6a-4542-80c3-fc955e859ae8-99",
    "data-name": "Path 1136",
    d: "M485.158,524.929a8.1571,8.1571,0,0,0-3.309-12.061L458.479,442.348l-15.651,8.348,27.893,66.692a8.2,8.2,0,0,0,14.437,7.54Z",
    transform: "translate(-252.95901 -161.92099)",
    fill: "#a0616a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ac8b856a-5bfa-484c-b494-50247cbd55c2-100",
    "data-name": "Path 1137",
    d: "M456.344,725.437h11.789l5.608-45.473h-17.4Z",
    transform: "translate(-252.95901 -161.92099)",
    fill: "#a0616a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bf312fd5-7892-49a0-80f0-ca7b5de9c452-101",
    "data-name": "Path 1138",
    d: "M453.338,736.865h38.013v-.481a14.79994,14.79994,0,0,0-14.795-14.8H453.337Z",
    transform: "translate(-252.95901 -161.92099)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "b136a9ae-9224-457c-984e-a201d5628fb8-102",
    "data-name": "Path 1139",
    d: "M409.077,466.796l-2.672,6.945.534,6.945,51.289-6.41-1.6-5.877-5.876-6.945Z",
    transform: "translate(-252.95901 -161.92099)",
    fill: "#a0616a"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "f094d8dd-8e3f-4b13-becb-dde723bd08d3",
    "data-name": "Ellipse 220",
    cx: 172.64701,
    cy: 223.70202,
    r: 18.672,
    fill: "#a0616a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "b5e48a2a-ea39-41a2-9198-5a39e8551573-103",
    "data-name": "Path 1140",
    d: "M406.121,474.24l50.858-5.41,2.2-7.206c.685-.939,7.14-10.087,5.708-19.233a15.929,15.929,0,0,0-6.881-10.666L445.645,417.247l-10.878-6.475-21.445-2.144-.074.016-19.253,4.357.234,35.292Z",
    transform: "translate(-252.95901 -161.92099)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "a6ca4a7f-9bf0-4dac-91b0-cdfc1c7b9469-104",
    "data-name": "Path 1141",
    d: "M455.699,477.98l14.249-1.692-.037-.448c-.131-1.573-3.247-38.629-6.439-47.14-3.26-8.694-17.382-11.4-17.981-11.513l-.173-.032-3.138,1.883,8.66,27.064Z",
    transform: "translate(-252.95901 -161.92099)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ab12339c-732c-43c0-9daa-a7ea979cb3b7-105",
    "data-name": "Path 1142",
    d: "M405.55505,480.577v11.732s-13.734,17.846-6.334,31.579c0,0-15.846,29.578-16.9,40.142l-14.79992,48.594s-36.973,36.973-33.8,63.382l-2.113,8.451,24.3,10.564,5.282-7.395,41.2-70.777,34.86-64.439,6.338,76.059s-4.225,59.157,7.395,65.5l1.056,9.507h24.658V694.437s9.146-32.161,3.864-56.458l2.113-102.468s-9.507-43.311-21.127-50.706L457.321,474.237Z",
    transform: "translate(-252.95901 -161.92099)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "be13f11d-97fc-491e-ab8f-21e9fef4281a-106",
    "data-name": "Path 1143",
    d: "M424.167,502.553a8.399,8.399,0,0,0-1.264.391l-32.6-22.438.746-9.585-14.318-3.016-2.969,16.84a6.384,6.384,0,0,0,3.465,6.835l40.379,19.914a8.37594,8.37594,0,1,0,6.561-8.939Z",
    transform: "translate(-252.95901 -161.92099)",
    fill: "#a0616a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "a464f869-97dd-44e8-a8d0-b87fc98c85b8-107",
    "data-name": "Path 1144",
    d: "M390.613,481.743l6.635-44.262,5.446-22.865-8.137-1.7c-.221-.082-6.847-2.322-12.2,1.284-3.85,2.6-5.983,7.522-6.339,14.641l-2.154,50.648Z",
    transform: "translate(-252.95901 -161.92099)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "a303ed3a-027a-4219-a7cd-863d3eefc723-108",
    "data-name": "Path 1145",
    d: "M438.436,361.308a23.453,23.453,0,0,0-35.657,20.468c10.437.48,21.4.6,32.519.627l2.627-6.431,1.549,6.435q5.081,0,10.182-.013A23.94712,23.94712,0,0,0,438.436,361.308Z",
    transform: "translate(-252.95901 -161.92099)",
    fill: "#2f2e41"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "fe23b7bc-1ca6-4ec5-9f56-67afc1ee089a-109",
    "data-name": "Path 1146",
    d: "M254.771,738.079H945.229c1,0,1.812-.448,1.812-1s-.812-1-1.812-1H254.771c-1,0-1.812.448-1.812,1S253.77005,738.079,254.771,738.079Z",
    transform: "translate(-252.95901 -161.92099)",
    fill: "#cbcbcb"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbtU);
export default __webpack_public_path__ + "static/media/abtU.59c68de41f459127ba4140ffcc9231aa.svg";
export { ForwardRef as ReactComponent };